import React, { ComponentProps, FC, ReactNode, useCallback } from 'react';
import { ProjectId } from 'api/models';
import { ActionPanel } from 'components/molecules/action-panel';
import { BulkAssigneePicker } from 'components/molecules/assignee-picker/bulk-assignee-picker';
import {
  AssigneeField,
  AssigneeValue,
} from 'components/organisms/tasks/fields';
import { useTranslation } from 'hooks/use-translation';
import { TaskField } from 'stores/fields';
import { OnChange } from '../bulk-editor';

const { PopoverAction } = ActionPanel;

type Props = {
  assignee: AssigneeField;
  title: ReactNode;
  allowed: ComponentProps<typeof PopoverAction>['allowed'];
  onChange: OnChange;
  projectIds: ProjectId[];
  isPrivate: boolean;
};

export const SetAssignee: FC<Props> = ({
  assignee,
  projectIds,
  isPrivate,
  title,
  allowed,
  onChange,
}) => {
  const onAssigneeChange = useCallback(
    (value: AssigneeValue[]) => {
      onChange(assignee as TaskField, value);
    },
    [onChange, assignee],
  );
  const saveTitle = useTranslation(
    'task_list.bulk_editor.options.assignee.save',
  );

  return (
    <BulkAssigneePicker
      title={title}
      allowed={allowed}
      saveTitle={saveTitle}
      assignee={assignee}
      isPrivate={isPrivate}
      projectIds={projectIds}
      onAssigneeChange={onAssigneeChange}
    />
  );
};
